import { Link } from 'react-router-dom';
import logo from '../assets/endurance.png';
import { useAuth } from '../auth/AuthProvider';
import { strings } from '../strings';
import { Icon } from './Icon';

// Design system §2: primary logo (navy wordmark) on a white header, scaled proportionally, with
// clear space of at least 50% of its height on every side and no text locked up to it. The logo
// is 40px tall, so the "Knowledge Base" title sits 20px+ away, separated by a rule.
export function Header({ tenantLink }: { tenantLink?: string }) {
  const { status, profile, organisation, signOut } = useAuth();
  return (
    <header className="border-b border-neutral-field bg-white">
      <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-x-8 gap-y-3 px-4 py-5">
        <div className="flex items-center">
          <Link to={tenantLink ?? '/'} className="block p-5" aria-label={`ENDURANCE ${strings.appName}, start page`}>
            <img src={logo} alt="ENDURANCE" className="h-10 w-auto" width={206} height={40} />
          </Link>
          <span className="ml-1 border-l border-neutral-field pl-6 font-heading text-h5 font-normal text-brand-prussian sm:text-h3">
            {strings.appName}
          </span>
        </div>
        {status === 'signedIn' && profile && (
          <div className="flex flex-wrap items-center gap-4 text-small">
            <span className="text-neutral-muted">
              {strings.header.signedInAs(profile.displayName)}
              {organisation ? ` · ${organisation.name}` : ''}
            </span>
            <button type="button" className="btn-secondary" onClick={() => void signOut()}>
              <Icon name="logout" />
              {strings.header.signOut}
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
